// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup-video .modal-box{max-width:960px;width:100%;padding:0}.popup-video__main{overflow:hidden;position:relative;margin:0 auto;max-width:960px;width:100%;height:0;padding-bottom:56.25%}.popup-video__main iframe{height:100%;left:0;position:absolute;top:0;width:100%;max-height:540px}.popup-video__main video{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
